export default __webpack_public_path__ + "static/affiliate-program-AffiliateApp@mob-45993a9fb1567391d3fe0f4568260b67.webp";